import _ from 'underscore';
import { ChoiceGroup } from '@fluentui/react';
import React, { useContext, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { StepContainer } from '../step-container/step-container';
import { GoalCreationWizardContext } from '../../goal-creation-wizard-context';
import { WIZARD_ACTIONS } from '../../goal-creation-wizard-reducer';

const GoalObjectiveStepUnstyled = (props) => {
  const {
    classes,
    autoGoalBackHandlerFunc,
  } = props;
  const i18n = useContext(I18nContext);
  const wizardContext = useContext(GoalCreationWizardContext);
  const { logActivity } = wizardContext;
  const [selectedOption, setSelectedOption] = useState(wizardContext.selectedObjective);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(!_.isUndefined(selectedOption));
  const optionSet = [
    { key: 'website', text: i18n.getString(_TL_('Website')) },
    { key: 'appInstall', text: i18n.getString(_TL_('Mobile app install')) },
    { key: 'import', text: i18n.getString(_TL_('Offline')) },
  ];

  const handleStart = useCallback(() => {
    logActivity.trace(`Selected goal objective:${selectedOption}`);
    wizardContext.goToNext();
  }, [logActivity, selectedOption, wizardContext]);

  const onChangeOptions = useCallback((ev, options) => {
    setSelectedOption(options.key);
    logActivity.trace(`Clicked goal objective:${options.key}`);
    wizardContext.dispatch({
      type: WIZARD_ACTIONS.SELECT_OBJECTIVE,
      value: options.key,
    });
    setIsNextButtonEnabled(true);
  }, [logActivity, wizardContext]);

  const footerConfig = useMemo(() => {
    const buttons = [{
      type: 'Primary-Start',
      onClick: handleStart,
      isEnabled: isNextButtonEnabled,
      text: i18n.getString(_TL_('Next')),
    },
    {
      type: 'Cancel',
      onClick: wizardContext.cancel,
      isEnabled: true,
      text: i18n.getString(_TL_('Cancel')),
    },
    ];

    if (autoGoalBackHandlerFunc) {
      buttons.push({
        type: 'BasicLink',
        onClick: autoGoalBackHandlerFunc,
        isEnabled: true,
        text: i18n.getString(_TL_('Switch to simplified setup')),
      });
    }
    return { buttons };
  }, [handleStart, isNextButtonEnabled, i18n, wizardContext, autoGoalBackHandlerFunc]);

  return (
    <StepContainer
      title={i18n.getString(_TL_('What kind of conversions do you want to track?'))}
      step="conversion-type"
      footerConfig={footerConfig}
    >
      <div className={classNames(classes.radioButtonsBlock, 'objective-radio-group')}>
        <ChoiceGroup
          className={classes.contentBlock}
          selectedKey={selectedOption}
          options={optionSet}
          onChange={onChangeOptions}
          aria-labelledby="conversion-type-title"
        />
      </div>
    </StepContainer>
  );
};

GoalObjectiveStepUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(getStepStyles(), _.constant(PropTypes.string.isRequired)))
    .isRequired,
  autoGoalBackHandlerFunc: PropTypes.func,
};

GoalObjectiveStepUnstyled.defaultProps = {
  autoGoalBackHandlerFunc: null,
};

export const GoalObjectiveStep = withPerfMarker(withDefaultStyles(GoalObjectiveStepUnstyled, getStepStyles));
